<template>
  <div class="main-body">
    <div class="header">老年大学</div>
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="commandCenterCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_comm"
                :key="item.commandCenterCode"
                :label="item.name"
                :value="item.commandCenterCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border
                row-key="goodsClassCode"
                :row-class-name="tableRowClassName"
                :tree-props="{children: 'secondGoodsClassList'}">

        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="icon" label="图标">
          <template slot-scope="scope">
            <el-popover placement="right" title="" trigger="click">
              <img :src="imgUrl+scope.row.icon"  style="width: 500px"/>
              <img slot="reference" :src="imgUrl+scope.row.icon" style="width:50px">
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="trainClassName" label="分类"></el-table-column>

        <el-table-column prop="status" label="状态" >
          <template slot-scope="scope">
            <el-tag type="success" slot="reference" v-if="scope.row.status==1">正常</el-tag>
            <el-tag type="danger" slot="reference" v-if="scope.row.status==2">禁用</el-tag>
          </template>
        </el-table-column>


        <el-table-column label="课程总数">
          <template slot-scope="scope">
            <span>{{scope.row.listTrainCourse.length}}</span>
          </template>
        </el-table-column>


      </el-table>


      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "Page",
  data(){
    return{

      showModalEditCourse:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      imgUrl:this.$imgUrl,

      arr_comm:[],
      commandCenterCode: '',

    }
  },
  created(){
    this.getComm();
    this.th = this.$store.state.tableHeight;
  },
  components:{

  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getComm(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CommandCenter/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_comm = response.data.data.list;
          if(this.arr_comm.length>0){
            this.commandCenterCode = this.arr_comm[0].commandCenterCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    handleEditCourse(index,row){
      this.$refs.myCourse.init(row);
      this.showModalEditCourse = !this.showModalEditCourse;
    },
    closeEditCourse:function(){
      this.showModalEditCourse = !this.showModalEditCourse;
    },



    getCreateTime(row) {
      return timefilters(row.createTime);
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Train/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          commandCenterCode:this.commandCenterCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },





  }
}
</script>

<style scoped>

</style>
